define("shared/components/shared/best-describes-question", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object"], function (_exports, _component, _templateFactory, _component2, _object) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/object",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--formWrapper--lg tSU--card__formWrapper qa--signup_bestdescribes_dropdown">
    <label>{{t "authorization.best_describes.select_best_description"}}</label>
    <PowerSelect
      @triggerClass="qa--signup_bestDescribes_dropdown"
      @renderInPlace={{true}}
      @searchEnabled={{false}}
      @placeholder={{t "profile_categorization.categorize_form.default_business_model_field"}}
      @options={{this.bestDescribesOptions}}
      @selected={{@selectedDescription}}
      @onChange={{@onSelectionChanged}}
      @onFocus={{this.open}}
      as |option|>
      <span class="qa-bestDescribes_{{option}}">{{t (concat "authorization.best_describes.options." option)}}</span>
    </PowerSelect>
  </div>
  
  */
  {
    "id": "E08FkWYd",
    "block": "[[[10,0],[14,0,\"o--formWrapper--lg tSU--card__formWrapper qa--signup_bestdescribes_dropdown\"],[12],[1,\"\\n  \"],[10,\"label\"],[12],[1,[28,[35,0],[\"authorization.best_describes.select_best_description\"],null]],[13],[1,\"\\n  \"],[8,[39,1],null,[[\"@triggerClass\",\"@renderInPlace\",\"@searchEnabled\",\"@placeholder\",\"@options\",\"@selected\",\"@onChange\",\"@onFocus\"],[\"qa--signup_bestDescribes_dropdown\",true,false,[28,[37,0],[\"profile_categorization.categorize_form.default_business_model_field\"],null],[30,0,[\"bestDescribesOptions\"]],[30,1],[30,2],[30,0,[\"open\"]]]],[[\"default\"],[[[[1,\"\\n    \"],[10,1],[15,0,[29,[\"qa-bestDescribes_\",[30,3]]]],[12],[1,[28,[35,0],[[28,[37,2],[\"authorization.best_describes.options.\",[30,3]],null]],null]],[13],[1,\"\\n  \"]],[3]]]]],[1,\"\\n\"],[13],[1,\"\\n\"]],[\"@selectedDescription\",\"@onSelectionChanged\",\"option\"],false,[\"t\",\"power-select\",\"concat\"]]",
    "moduleName": "shared/components/shared/best-describes-question.hbs",
    "isStrictMode": false
  });

  let BestDescribesQuestionComponent = (_class = class BestDescribesQuestionComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _defineProperty(this, "defaultBestDescribesOptions", ['small_business_owner', 'creator_influencer', 'social_media_manager_lead', 'marketing_agency', 'other']);
    }

    get bestDescribesOptions() {
      var _this$args$bestDescri;

      return (_this$args$bestDescri = this.args.bestDescribesOptions) !== null && _this$args$bestDescri !== void 0 ? _this$args$bestDescri : this.defaultBestDescribesOptions;
    }

    open(powerSelectApi) {
      if (!powerSelectApi.isOpen) {
        powerSelectApi.actions.open();
      }
    }

  }, (_applyDecoratedDescriptor(_class.prototype, "open", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "open"), _class.prototype)), _class);
  _exports.default = BestDescribesQuestionComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, BestDescribesQuestionComponent);
});